export default __webpack_public_path__ + "static/coastal-1e6375f0213cf302b1ac26aef66c752c.png";